import { render, staticRenderFns } from "./MLyricSearch.vue?vue&type=template&id=d4b60298&scoped=true"
import script from "./MLyricSearch.vue?vue&type=script&lang=js"
export * from "./MLyricSearch.vue?vue&type=script&lang=js"
import style0 from "./MLyricSearch.vue?vue&type=style&index=0&id=d4b60298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b60298",
  null
  
)

export default component.exports